import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';
import { CREATE_USER_GROUP_RESOURCE, USER_GROUPS_RESOURCE } from '../../constants';
import { createErrorMessage } from '../../../app/helpers/createErrorMessage';

const CreateUserGroupService = ComposedComponent =>
  reduxFetch([
    {
      resource: CREATE_USER_GROUP_RESOURCE,
      method: 'post',
      request: (organisationId, body, callback, rejectCallback, t) => ({
        url: apiRoutes.userGroups(organisationId),
        body,
        meta: {
          callback,
          rejectCallback,
          addToOtherList: {
            resource: USER_GROUPS_RESOURCE,
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'createUserGroupFailed'),
            onSuccessMessage: t('createUserGroupSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default CreateUserGroupService;
